import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCompanyPlatform } from "../services"; // Importar la función para hacer la petición

// Thunk asíncrono para obtener los datos de hero desde la API
export const fetchCompanyPlatformData = createAsyncThunk("hero/fetchCompanyPlatformData", async (_, { rejectWithValue }) => {
  try {
    const data = await fetchCompanyPlatform(); // Llama al servicio de la API
    return data;
  } catch (error) {
    return rejectWithValue(error.message); // Manejo de errores
  }
});

const companyPlatformSlice = createSlice({
  name: "companyPlatform",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Puedes agregar más acciones sincronas si es necesario
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyPlatformData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyPlatformData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCompanyPlatformData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default companyPlatformSlice.reducer;
